import React, { useCallback } from "react";

import { faPlusCircle } from "@awesome.me/kit-4c83d50d0d/icons/classic/light";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Button, useModals } from "~/ui";

import useActionItemGroupItemsKey from "../hooks/useActionItemsGroupItemsKey";
import CreateOrEditActionItemGroup from "./CreateOrEditActionItemGroup";

import styles from "./CreateActionItemGroupButton.module.css";

interface CreateActionItemGroupButtonProps {
	order: number;
}

export default function CreateActionItemGroupButton({ order }: CreateActionItemGroupButtonProps) {
	const itemsKey = useActionItemGroupItemsKey();
	const modals = useModals();
	const onClick = useCallback(() => {
		modals.open(({ close }) => <CreateOrEditActionItemGroup onClose={close} order={order} itemsKey={itemsKey} />);
	}, [modals, order, itemsKey]);

	return (
		<Button size="wide" className={styles.createButton} onClick={onClick}>
			<FontAwesomeIcon icon={faPlusCircle} />
			<span>Create new group</span>
		</Button>
	);
}
